module.exports = __webpack_public_path__ + "img/icon-shipping-combined.01e574bb.svg";